<section>
    <div id="slider">
        <div id="headerSlider" class="carousel slide" data-ride="carousel">
            <!-- <ol class="carousel-indicators">
        <li data-target="#headerSlider" data-slide-to="0" class="active"></li>

      </ol> -->
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img
                        src="../assets/images/banner1.jpg"
                        class="d-block w-100"
                    />
                    <div class="carousel-caption">
                        <div class="banner-text">
                            <!-- <h4 class="">Our Three Pillars</h4> -->
                            <!-- <h5>STRIDE &middot; STRIVE &middot; SOAR</h5> -->
                            <div class="search">
                                <input
                                    class="form-control"
                                    ngx-google-places-autocomplete
                                    [options]="options"
                                    #placesRef="ngx-places"
                                    (onAddressChange)="
                                        handleAddressChange($event)
                                    "
                                    placeholder="Enter Address, Neighborhood, City or Region"
                                />
                                <!-- {{formattedAddress}} -->
                            </div>
                            <!-- <hr /> -->
                            <!-- <h6>Or</h6> -->
                            <!-- <div class="second-search">
                                <form
                                    (submit)="submitForm(searchForm)"
                                    #searchForm="ngForm"
                                >
                                    <div class="form-group row">
                                        <label
                                            class="col-sm-2 col-form-label hidden"
                                            >Locality</label
                                        >
                                        <div class="col-sm-10">
                                            <input
                                                type="text"
                                                class="form-control"
                                                placeholder="Locality"
                                                ngModel
                                                name="area"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label
                                            class="col-sm-2 col-form-label hidden"
                                            >Beds</label
                                        >
                                        <div class="col-sm-4">
                                            <input
                                                type="text"
                                                class="form-control space-below"
                                                ngModel
                                                placeholder="Beds"
                                                name="beds"
                                            />
                                        </div>
                                        <label
                                            class="col-sm-2 col-form-label hidden"
                                            >Baths</label
                                        >
                                        <div class="col-sm-4">
                                            <input
                                                type="text"
                                                class="form-control"
                                                ngModel
                                                placeholder="Baths"
                                                name="baths"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label
                                            class="col-sm-2 col-form-label hidden"
                                            >Min Price</label
                                        >
                                        <div class="col-sm-4">
                                            <input
                                                type="text"
                                                class="form-control space-below"
                                                ngModel
                                                placeholder="Minimum Price"
                                                name="minPrice"
                                            />
                                        </div>
                                        <label
                                            class="col-sm-2 col-form-label hidden"
                                            >Max Price</label
                                        >
                                        <div class="col-sm-4">
                                            <input
                                                type="text"
                                                class="form-control"
                                                ngModel
                                                placeholder="Max Price"
                                                name="maxPrice"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-sm-2 offset-sm-10">
                                            <button
                                                type="submit"
                                                class="btn btn-stride"
                                            >
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="description">
    <div class="container">
        <div class="heading text-center">
            <h1>Stride Real Estate</h1>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="col-md-12 description-item">
                    <i class="fas fa-home"></i>
                    <h5>Wide Range of Properties</h5>
                    <p>
                        We are proud to provide service in all areas of Real
                        Estate, from beautiful custom residential homes to
                        unique commercial properties, we are a one-stop source
                        for any of your personal and professional real estate
                        needs.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="col-md-12 description-item">
                    <i class="far fa-building"></i>
                    <h5>Rent or Sale</h5>
                    <p>
                        Whether you are looking to buy or lease, we listen to
                        you and work with your style. We have a myriad of
                        options our dedicated agents would be happy to show you
                        and tailor to your preference.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="col-md-12 description-item">
                    <i class="far fa-map"></i>
                    <h5>Property Location</h5>
                    <p>
                        We cater to the Dallas-Fort Worth Metroplex and
                        surrounding suburbs. Nonetheless, no distance is too far
                        for our dedicated agents when it comes to finding you
                        the perfect deal. We have a branch in Houston, TX as
                        well!
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="our_location">
    <div class="container">
        <div class="heading text-center">
            <h1>Our Locations</h1>
        </div>
        <div class="row">
            <ng-container *ngFor="let location of locations">
                <div class="col-md-4" (click)="openLocation(location.state)">
                    <div class="col-md-12 location-item">
                        <img src="{{ location.icon }}" alt="" />
                        <h5>{{ location.state }}</h5>
                        <svg></svg>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</section>
